import { CSSProperties } from 'react';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { QualityCommercialConfig, subFuncInfo } from '@/types';

export enum ExtensionType {
    popUp = 'popUp',
    fullCover = 'fullCover',
    panel = 'panel',
}

export interface IExtensionModel {
    display: boolean;
    style: CSSProperties;
    setDisplay: (payload: boolean) => void;
    setStyle: (payload: CSSProperties) => void;
    type?: ExtensionType;
    setType: (payload: ExtensionType) => void;
    /** 变清晰商业化配置 */
    qualityCommercialConfig: QualityCommercialConfig;
    setQualityCommercialConfig: (payload: QualityCommercialConfig) => void;
}

const useExtensionModel = create<IExtensionModel>()(
    immer((set) => ({
        display: false,
        setDisplay: (payload) =>
            set((state) => {
                state.display = payload;
            }),
        style: {},
        setStyle: (payload) =>
            set((state) => {
                state.style = payload;
            }),
        type: ExtensionType.popUp,
        setType: (payload) =>
            set((state) => {
                state.type = payload;
            }),
        qualityCommercialConfig: subFuncInfo,
        setQualityCommercialConfig: (payload) =>
            set((state) => {
                state.qualityCommercialConfig = payload;
            }),
    })),
);

export { useExtensionModel };
export const getExtensionModel = () => useExtensionModel.getState();
